"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationDialogEditForm = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const CustomDialog_1 = require("./CustomDialog");
const LocationForm_1 = require("./LocationForm");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const button_1 = require("primereact/button");
const LocationDialogEditForm = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)(['common', 'metrology']);
    const [saveAndNewClicked, setSaveAndNewClicked] = (0, react_1.useState)(false);
    const customButtons = [
        (0, jsx_runtime_1.jsx)(button_1.Button, { type: 'submit', form: 'formLocation', label: t('saveAndNew'), icon: "pi pi-plus", className: "p-button-text", disabled: false, onClick: () => {
                setSaveAndNewClicked(true);
            } })
    ];
    return ((0, jsx_runtime_1.jsx)(CustomDialog_1.CustomDialog, Object.assign({ header: props.selectedLocations.length > 0 ? t('loc_editLocationDialog_header') : t('loc_createLocationDialog_header'), headerType: props.selectedLocations.length > 0 ? CustomDialog_1.CustomDialogHeaderType.Update : CustomDialog_1.CustomDialogHeaderType.Create, formName: 'formLocation', onCancel: () => {
            if (props.setSelectedLocations)
                props.setSelectedLocations([]);
            if (props.setEditLocation)
                props.setEditLocation(false);
        }, visible: typeof props.editLocation === 'boolean' ? props.editLocation : false, maximized: true, customButtons: props.showSaveAndNewButton ? customButtons : null }, { children: (0, jsx_runtime_1.jsx)(LocationForm_1.LocationForm, { project: props.project, location: props.selectedLocations.length > 0 ? props.selectedLocations[0] : null, saveAndNewClicked: saveAndNewClicked, keycloakfetch: props.keycloakfetch, settings: props.settings, onFinished: () => {
                if (props.setReloadLocations)
                    props.setReloadLocations(true);
                if (saveAndNewClicked) {
                    // Setze lokalen state zurück
                    setSaveAndNewClicked(false);
                }
                else {
                    // Zerstöre den Dialog wenn auf Speichern (nicht auf 'Speichern und weitere anlegen') geklickt wurde
                    if (props.setEditLocation)
                        props.setEditLocation(false);
                }
            }, isProjectCenter: props.isProjectCenter }) })));
};
exports.LocationDialogEditForm = LocationDialogEditForm;
